import { useCallback } from "react";
import { useDropzone } from "react-dropzone";

export default function UploadImage({ onFileSelect, preview }) {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        onFileSelect(acceptedFiles[0]);
      }
    },
    [onFileSelect],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      className={`border-2 border-dashed rounded-xl p-6 text-center cursor-pointer
        ${isDragActive ? "border-blue-500 bg-blue-50" : "border-gray-300"}`}
    >
      <input {...getInputProps()} />

      {preview ? (
        <img
          src={preview}
          alt="Preview"
          className="mx-auto h-32 object-cover rounded-lg"
        />
      ) : (
        <p className="text-gray-500">
          Drag & drop an image here, or click to select
        </p>
      )}
    </div>
  );
}
